module.exports = __webpack_public_path__ + "img/image5.57f25de3.png";